import Step from "@frog/source/models/Step.js"
import World from "@frog/source/models/World.js"
import Stage from "@frog/source/models/Stage.js"
import skills from "@frog/source/data/skills.js"
import InkDialogue from "@frog/source/utility/integration/InkDialogue.js"
import Dev from "@frog/source/models/admin/Dev.js"
import App from "@frog/source/models/App.js"

export default class Reactions {
    static getSteps(stage) {
        let steps = []

        // while(Reactions.getDeaths(stage).length > 0) {
        const deaths = Reactions.getDeaths(stage)
        deaths.forEach((death) => {
            const unit = stage.units[death.unitKey]

            if(Dev.isAllyDeathEnabled != true
            && unit.affiliation == "good") {
                return
            }
            unit.skills.forEach((skillKey) => {
                const skill = skills.get(skillKey)
                if(skill == undefined) return
                if(skill.type != "death") return
                if(skill.calculateStep instanceof Function) {
                    const step = skill.calculateStep({
                        "performerKey": unit.key,
                        "stage": stage,
                    })
                    stage = step.omegastage
                    steps.push(step)
                }
            })
            // TODO: what happens if multiple folks die at once, and i try to
            // run their skills all off the same stage (not a rolling omegastage)
            // I need to have something similiar to Step.add(step, deltastage)
            // but for Action.add(action, step)
        })

        deaths.forEach((death) => {
            // steps = steps.concat(Stage.getEventSteps(stage, "death:" + stage.units[death.unitKey].key))
            // stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            //
            // steps = steps.concat(Stage.getEventSteps(stage, "death:" + stage.units[death.unitKey].type))
            // stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

            const unit = stage.units[death.unitKey]

            if(Dev.isAllyDeathEnabled != true
            && unit.affiliation == "good") {
                return
            }
            if(unit.dialogue != undefined
            && unit.dialogue["death"] != undefined) {
                if(unit.dialogue["death"] instanceof Array == false) {
                    unit.dialogue["death"] = new Array(unit.dialogue["death"])
                }
                steps.push(Step.instantiate({
                    "type": "StartDialogue",
                    "isImportant": true,
                    "duration": Infinity,
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "dialogue": {
                                "text": ("The " + unit.jobName + " has taken a fatal blow.").toUpperCase(),
                            }
                        }
                    ]
                }))
                unit.dialogue["death"].forEach((line) => {
                    steps.push(Step.instantiate({
                        "type": "StartDialogue",
                        "isImportant": true,
                        "duration": Infinity,
                        "alphastage": stage,
                        "deltastages": [
                            {
                                "mark": 0,
                                "dialogue": {
                                    "text": line,
                                    "data": {
                                        "unitKey": unit.key,
                                    }
                                }
                            }
                        ]
                    }))
                })
                // TODO: there is a weird flash between dialogue here.
                // TODO: at a later time, unify how we do dialogue with Plotscripts.Dialogue!!
                steps.push(Step.instantiate({
                    "type": "FinishDialogue",
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "dialogue": undefined
                        }
                    ]
                }))
                stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            }

            steps = steps.concat(InkDialogue(death.unitKey + "_" + "death", stage))
            stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

            if(unit.hasSlowDeath == true) {
                steps.push(Step.instantiate({
                    "name": "death",
                    "type": "invoke skill",
                    "alphastage": stage,
                    "deltastages": [
                        {
                            "mark": 0,
                            "unit": {
                                "key": death.unitKey,
                                "deathTimer": 2,
                                "power": 100,
                            }
                        }
                    ]
                }))
                return
            }

            stage.conditions.forEach((condition) => {
                if(condition.type == "death"
                && condition.unitKey == death.unitKey) {
                    steps = steps.concat(Stage.processEventSteps(stage, condition.events))
                    stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
                }
            })

            steps.push(Step.instantiate({
                "name": "death",
                "type": "invoke skill",
                "alphastage": stage,
                "deltastages": [
                    {
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Death"},
                    },
                    {
                        "mark": 0,
                        "unit": {"key": death.unitKey, "opacity": 1}
                    },
                    {
                        "mark": 300,
                        "unit": {"key": death.unitKey, "opacity": 0}
                    },
                    {
                        "mark": 300,
                        "unit": {"key": death.unitKey, "isDead": true}
                    },
                    // {
                    //     "mark": 300,
                    //     "stage": {
                    //         "units": {
                    //             [death.unitKey]: undefined,
                    //         },
                    //     }
                    // },
                    {
                        "mark": 300,
                        "func": function() {
                            if(unit.affiliation == "bad") {
                                App.tutorial.hasKilled = true
                            }
                        }
                    }
                ]
            }))
            stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
        })

        // One big death event for all the units dying? Or individual deaths?
        // TO THINK ABOUT: How to handle death text?
        // TO THINK ABOUT: How to overlap this and the death text with the killing blows?
        // TODO: change this to the new schema v2

        return steps
    }
    static getDeaths(stage) {
        const deaths = Object.values(stage.units).map((unit) => {
            if(unit.type == "zone") return // Zones can not be killed.
            if(unit.deathTimer != undefined) return // That which is dying can not be killed.
            if(unit.isDead == true) return // The dead can not be rekilled.
            if(unit.hasBeenRemoved == true) return
            if(unit.position.x == -10 && unit.position.y == -10) return

            if(unit.health <= 0) {
                return {"unitKey": unit.key, "type": "death-by-damage"}
            }

            const killzone = Object.values(stage.units).find((nextunit) => {
                return nextunit.type == "zone"
                    && nextunit.intent == "kill"
                    && nextunit.position.x == unit.position.x
                    && nextunit.position.y == unit.position.y
            })
            if(killzone != undefined) {
                return {"unitKey": unit.key, "type": "death-by-falling"}
            }

            const nextTerrain = World.getTerrain(stage.world, unit.position)
            if(nextTerrain == undefined) {
                return {"unitKey": unit.key, "type": "death-by-falling"}
            }
            // TODO: Death by leaving zone?
            // TODO: Death by change of height?
            // TODO: Death by being over "z<0"
        })

        return deaths.filter((death) => !!death)
    }
}
